import React from 'react';
import { AlertTriangle, TrendingUp, Shield } from 'lucide-react';

const RiskSection = ({
  formData,
  handleInputChange,
  errors,
  exchangeRateScenarios,
  riskToleranceLevels
}) => {
  return (
    <div className="mb-6 bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <AlertTriangle className="w-5 h-5 mr-2 text-amber-500" />
        Анализ валютных рисков
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сценарий изменения курса */}
        <div>
          <label htmlFor="exchangeRateScenario" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <TrendingUp className="w-4 h-4 mr-2 text-amber-500" />
            Сценарий изменения курса
          </label>
          <select
            id="exchangeRateScenario"
            name="exchangeRateScenario"
            value={formData.exchangeRateScenario}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.exchangeRateScenario ? 'input-error' : ''}`}
          >
            {exchangeRateScenarios.map((scenario) => (
              <option key={scenario.id} value={scenario.id}>
                {scenario.name} - {scenario.description}
              </option>
            ))}
          </select>
          {errors.exchangeRateScenario && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.exchangeRateScenario}
            </p>
          )}
        </div>

        {/* Уровень толерантности к валютным рискам */}
        <div>
          <label htmlFor="currencyRiskTolerance" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Shield className="w-4 h-4 mr-2 text-amber-500" />
            Толерантность к валютному риску
          </label>
          <select
            id="currencyRiskTolerance"
            name="currencyRiskTolerance"
            value={formData.currencyRiskTolerance}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.currencyRiskTolerance ? 'input-error' : ''}`}
          >
            {riskToleranceLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name} - {level.description}
              </option>
            ))}
          </select>
          {errors.currencyRiskTolerance && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.currencyRiskTolerance}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-amber-100 dark:bg-amber-900/30 p-3 rounded-lg border border-amber-200 dark:border-amber-800">
        <div className="flex items-start">
          <AlertTriangle className="w-5 h-5 text-amber-600 dark:text-amber-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-amber-700 dark:text-amber-300 mb-1">
              Важная информация о валютных рисках
            </h4>
            <p className="text-xs text-amber-600 dark:text-amber-400">
              Валютная ипотека подвержена риску изменения курса валют. При ослаблении рубля платеж в рублях может значительно увеличиться. 
              Выбирайте сценарий исходя из ваших ожиданий относительно будущей динамики курса валюты.
              Уровень толерантности к риску должен соответствовать вашим финансовым возможностям.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskSection;